export default {
  title: 'KeyPal マネージャー',
  desc: 'KeyPal ファームウェア更新ツール',
  download: 'KeyPal Bridge をダウンロード',
  onLine: 'オンラインアップグレード',
  goDesktop: 'パソコンで操作してください',
  macTitle: 'Mac(Apple シリコン)',
  question_1: 'デスクトップアプリで KeyPal をアップグレードする方法は？',
  question_2: 'Web でアップグレードする方法は？',
}
